import { h, createContext, ComponentChildren, JSX } from 'preact';
import { useState } from 'preact/hooks';

export const DebugContext = createContext<{
  debug: boolean;
  setDebug: (debug: boolean) => void;
}>({
  debug: true,
  setDebug: () => {},
});

export const DebugProvider = ({ children }: { children: ComponentChildren }): JSX.Element => {
  const [debug, setDebug] = useState(false);
  return (
    <DebugContext.Provider value={{ debug, setDebug }} >
      {children}
    </DebugContext.Provider>
  )
}
